import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Partition } from '@classes/simulation/partition';
import { SimulationFlagType } from '@enums/simulation-flag-type.enum';

@Component({
    selector: 'app-partitions-tree-node',
    templateUrl: './partitions-tree-node.component.html',
    styleUrls: ['./partitions-tree-node.component.scss']
})
export class PartitionsTreeNodeComponent implements OnInit {
    @Input() node: Partition;
    @Input() selectedNodeCode: string;
    @Output() nodeSelected = new EventEmitter<Partition>();

    flagType = SimulationFlagType;

    constructor() { }

    ngOnInit() {
    }

    onClickNode(node): void {
        this.nodeSelected.emit(node);
    }
}
